import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';

// clipboard
Vue.use(VueClipboard);
